export default async function populateInvolves(users, sales) {
    try {
        console.log(users);
        console.log(sales);
    } catch (err) {
        console.log(err);
    }
}
